import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useCore } from 'contexts/core';
import SheetHeader from 'ui/Sheet/SheetHeader';
import Title from 'ui/Typography/Title';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import Body from 'ui/Typography/Body';
import Sheet from 'ui/Sheet/Sheet';
import {
  KompisSheetFooterButtons,
  KompisSheetFooter,
  KompisSheetBody,
  KompisSheetBodyPadding
} from '@inter-ikea-kompis/react-components';
import topInfoImage from './topInfo.png';
import { isMobile } from 'utils/platform';
import Box from 'ui/Box';
import styled from 'styled-components';
import { useAppDispatch } from 'ducks/hooks';
import { TopPanelSystem } from '@inter-ikea-storageone/range';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { isModalVisible, hideTopInfoSheet } from './TopInfoFeature';

const Image = styled.img`
  width: 100%;
`;

const TopInfoSheet = () => {
  const coreApi = useCore();
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const visible = !!useSelector(isModalVisible);
  const topPanelSystem = coreApi.getSystem<TopPanelSystem>('TopPanelSystem');

  const onBack = () => {
    dispatch(hideTopInfoSheet());
  };

  const onClose = () => {
    dispatch(hideTopInfoSheet());
  };

  const onButtonClickHandler = (event: CustomEvent) => {
    if (event.detail.type === 'primaryButton') {
      topPanelSystem?.enable();
    } else {
      topPanelSystem?.disable();
    }
    dispatch(hideTopInfoSheet());
  };

  return (
    <Sheet onOverlayClick={onClose} visible={visible}>
      <SheetHeader backIcon={!isMobile()} onBackButtonClick={onBack} onCloseButtonClick={onClose} />
      <KompisSheetBody theme={SkapaTheme}>
        <KompisSheetBodyPadding theme={SkapaTheme}>
          <Title type={ThemeFontStyleTypeEnum.headingMedium}>
            {formatMessage({ id: 'storageone.platsaTopToggleQuestionLabel' })}
          </Title>
          <Body mt={'l'} type={ThemeFontStyleTypeEnum.bodyLarge}>
            {formatMessage({ id: 'storageone.topPanelModalText' })}
          </Body>
          <Box mt={'l'} style={{ width: '100%' }}>
            <Image src={topInfoImage} alt={'Top image'} />
          </Box>
        </KompisSheetBodyPadding>
      </KompisSheetBody>
      <KompisSheetFooter theme={SkapaTheme}>
        <KompisSheetFooterButtons
          theme={SkapaTheme}
          primaryLabel={formatMessage({
            id: 'storageone.addTopPanel'
          })}
          secondaryLabel={formatMessage({
            id: 'storageone.dontAddTopPanel'
          })}
          onButtonClick={event => onButtonClickHandler(event)}
        />
      </KompisSheetFooter>
    </Sheet>
  );
};

export default TopInfoSheet;
